
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/fyrirtaekjaskraning",
      function () {
        return require("private-next-pages/um/thjonusta/fyrirtaekjaskraning.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/fyrirtaekjaskraning"])
      });
    }
  